function asArray(value) {
    return Array.isArray(value) ? value : [];
}
function firstString(...values) {
    for (const value of values) {
        if (typeof value === 'string' && value.trim())
            return value.trim();
    }
    return undefined;
}
function normalizeScore(value) {
    if (typeof value !== 'number' || !Number.isFinite(value))
        return undefined;
    const scaled = value <= 1 ? value * 100 : value;
    return Math.max(0, Math.min(100, Math.round(scaled)));
}
export function getB2BAudienceMetrics(analysis) {
    const mechanics = asArray(analysis?.audienceBuyingMechanics);
    const briefs = asArray(analysis?.audienceContentBriefs);
    const readinessProfiles = asArray(analysis?.audienceReadinessProfiles);
    const actorRefs = asArray(analysis?.selectedActorRefs);
    const audienceIds = Array.from(new Set([
        ...mechanics.map((item) => item?.audienceId),
        ...briefs.map((item) => item?.audienceId),
        ...readinessProfiles.map((item) => item?.audienceId),
    ].filter(Boolean)));
    return audienceIds.map((audienceId) => {
        const mechanic = mechanics.find((item) => item?.audienceId === audienceId);
        const brief = briefs.find((item) => item?.audienceId === audienceId);
        const readiness = readinessProfiles.find((item) => item?.audienceId === audienceId);
        const actorRef = actorRefs.find((item) => item?.audienceId === audienceId);
        return {
            audienceId,
            audienceName: firstString(brief?.audienceName, mechanic?.audienceName, actorRef?.audienceName),
            primaryReaderRole: firstString(brief?.primaryReaderRole, brief?.who?.primaryReaderRole, readiness?.recommendedStrategy?.bestPrimaryReaderRole),
            primaryReaderPosition: firstString(brief?.who?.primaryReaderPosition),
            readerDescription: firstString(brief?.who?.readerDescription, brief?.readerDescription, brief?.who?.primaryReaderPosition, brief?.primaryReaderRole),
            contentJob: firstString(brief?.contentJob),
            mainBarriers: asArray(brief?.mainBarriers).map(String).filter(Boolean),
            proofNeeds: asArray(brief?.proofNeeds).map(String).filter(Boolean),
            gatekeeperRisks: asArray(brief?.gatekeeperRisks).map(String).filter(Boolean),
            readinessStage: firstString(readiness?.readinessStage),
            stage: firstString(readiness?.stage),
            temperature: firstString(readiness?.temperature),
            warmingNeed: firstString(readiness?.warmingNeed),
            buyingSequenceHint: firstString(readiness?.buyingSequenceHint),
            score: normalizeScore(readiness?.score),
            confidence: normalizeScore(readiness?.confidence),
            primaryObjective: firstString(readiness?.recommendedStrategy?.primaryObjective),
        };
    });
}
export function hasB2BAudienceLayer(analysis) {
    return analysis?.mode === 'b2b' || getB2BAudienceMetrics(analysis).length > 0;
}
export function averageAudienceScore(metrics) {
    const scores = metrics
        .map((metric) => metric.score)
        .filter((score) => typeof score === 'number');
    if (scores.length === 0)
        return undefined;
    return Math.round(scores.reduce((sum, score) => sum + score, 0) / scores.length);
}
export function formatReadiness(metric) {
    return [
        metric.stage,
        metric.temperature,
        metric.readinessStage,
    ].filter(Boolean).join(' / ') || 'readiness unknown';
}
export function formatAudienceLabel(metric) {
    return metric.audienceName ? `${metric.audienceName} (${metric.audienceId})` : metric.audienceId;
}
